import React from 'react';

export function useToggle(initialState = false) {
  const [state, setState] = React.useState(initialState);
  const toggle = React.useCallback((value?: boolean) => setState(state => value === undefined ? !state : value), []);

  return { state, toggle };
}
